module.exports = __webpack_public_path__ + "img/manifestation-journal_B09PMFWZ48.11406099.jpg";